<script>
import VueQr from 'vue-qr'

export default {
  components: { VueQr },
  page: {
    title: 'Reset Password',
    meta: [{ name: 'description', content: 'The Reset Password page.' }],
  },
  computed: {
    isMobileDevice() {
      const userAgent = navigator.userAgent.toLowerCase()
      return /android|webos|iphone|ipad|ipod|blackberry|windows phone/.test(
        userAgent
      )
    },
    confirmLink() {
      const url = new URL(window.location.href)
      const hostname = url.hostname.split('.')
      const environment = hostname[0]

      const environmentMap = {
        staging: 'hbp-staging',
        dev: 'hbp-development',
        'hbp-dev2': 'hbp-dev2',
        'hbp-qa3': 'hbp-qa3',
        'hbp-stg2': 'hbp-stg2',
        silverhand: 'hbp-silverhand',
        myhealthbookplus: 'hbp', // For production without subdomain
      }
      const customScheme = environmentMap[environment] || 'hbp'

      return `${customScheme}://(auth)/code-retrieval`
    },
    qrCodeLink() {
      return window.location.href
    },
  },
  mounted() {
    if (this.isMobileDevice) {
      window.location.href = this.confirmLink
    }
  },
}
</script>

<template>
  <v-container fluid class="px-6">
    <v-row>
      <v-col :class="$style.title"> Resend code </v-col>
    </v-row>

    <v-row v-if="isMobileDevice">
      <v-col cols="12" class="py-2 px-2 font-weight-bold">
        We are currently preparing to resend your code for the HealthBook+ app.
      </v-col>
      <v-col cols="12" class="py-2 px-2">
        If the app doesn’t open automatically, please tap the link below to
        continue the process manually:
      </v-col>
      <v-col cols="12" class="py-2 px-2">
        <a :href="confirmLink">Resend code</a>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="12" :class="$style.description">
        To continue with resending the code, please use your mobile device to
        scan the QR code below.
      </v-col>
      <v-row justify="center">
        <VueQr :text="qrCodeLink" :size="250"></VueQr>
      </v-row>
      <v-col cols="12" class="mb-4" :class="$style.description">
        Scanning the code will open the HealthBook+ app, where you can complete
        the process by filling out the required form.
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.title {
  font-size: 1.25em;
  text-align: center;
}
.description {
  font-size: 0.9em;
}
</style>
